import React, { memo } from 'react';
import bem from 'utils/bem';
import dayjs from 'dayjs';
import { defaultTimezone } from 'utils/dayjs';
import { PickersDay, StaticDatePicker } from '@mui/x-date-pickers';
import Icon from 'components/Icon';

import './index.sass';

const { cnBlock, el } = bem('datepicker');
const DatePicker = ({ className, date, setDate, dates, selected, ...rest }) => {
    const shouldDisableDate = (day) => ![ ...dates, date ].includes(day.tz(defaultTimezone).format('DD.MM.YYYY'));

    const onChange = (day) => {
        setDate(day);
    }

    const Day = (props) => {
        const { day, ...other } = props;
        const isAlreadySelected = selected.includes(day.tz(defaultTimezone).format('DD.MM.YYYY'));
        return (
            <PickersDay
                className={el('day', {'already-selected': isAlreadySelected})}
                { ...other }
                day={ day }
            />
        );
    }

    const slots = {
        rightArrowIcon: () => <Icon className={ el('next-month') } name={ 'caret-down' }/>,
        leftArrowIcon: () => <Icon className={ el('prev-month') } name={ 'caret-down' }/>,
        day: Day
    }

    const slotProps = {
        nextIconButton: {
            disableRipple: true,
            disableFocusRipple: true
        },
        previousIconButton: {
            disableRipple: true,
            disableFocusRipple: true
        }
    }
    const daysOfWeekFormatter = (day) => day.charAt(0).toUpperCase() + day.slice(1);

    return (
        <StaticDatePicker
            value={ date ? dayjs(date).tz(defaultTimezone) : null }
            displayStaticWrapperAs='desktop'
            dayOfWeekFormatter={ daysOfWeekFormatter }
            disablePast={ true }
            shouldDisableDate={ shouldDisableDate }
            views={ [ 'day' ] }
            className={ cnBlock(className) }
            showDaysOutsideCurrentMonth={ true }
            fixedWeekNumber={ 6 }
            slots={ slots }
            slotProps={ slotProps }
            onChange={ onChange }
            timezone={ defaultTimezone }
            {...rest}
        />
    )
}

export default memo(DatePicker);

